import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import UneditableInput from '../../components/UneditableInput';
import EditableInput from '../../components/EditableInput/EditableInput';
import ContentEditor from '../../pages/EducationCourse/components/ContentEditor';
import { createLesson, updateLesson, getLessonById } from '../../services/education';
import { Button, TextField } from '@material-ui/core';
import { toast } from '@getpingback/realeza';
import { formatDuration } from '../../helpers/utils';
import { TrashCanIcon, PlusIcon } from '@stash-ui/regular-icons';

const initialCourse = {
  name: '',
  description: '',
  bannerUrl: '',
  content: '',
  videoUrl: '',
  supportingMaterials: [],
};
const EducationSpecialClass = () => {
  const { id } = useParams();

  const [course, setCourse] = useState(initialCourse);
  const [courseId, setCourseId] = useState(null);

  const editable = ['bannerUrl', 'videoUrl'];
  const uneditable = ['id', 'createdAt', 'updatedAt'];

  useEffect(() => {
    if (id) {
      setCourseId(id);
      handleGetCourse();
    }
  }, [id]);

  const handleGetCourse = async () => {
    try {
      const { data } = await getLessonById(id);
      setCourse(data);
    } catch (error) {
      console.log(error);
    }
  };
  const courseToSend = {
    name: course.name,
    bannerUrl: course.bannerUrl,
    duration: course.duration || 0,
    content: course.content,
    videoUrl: course.videoUrl,
    supportingMaterials: course?.supportingMaterials?.length
      ? course.supportingMaterials.map(material => ({
          name: material.name,
          url: material.url,
        }))
      : [],
  };

  const handleCreateCourse = async () => {
    try {
      const courseToSendWithType = { ...courseToSend, type: 'unique_lesson' };
      const { data } = await createLesson(courseToSendWithType);
      setCourse(data);
      setCourseId(data.id);
      toast.success('Special class created successfully');
    } catch (error) {
      console.log(error);
      toast.error(`Error creating special class: ${error.response.data.error.message}`);
    }
  };

  const handleUpdateCourse = async () => {
    try {
      const { data } = await updateLesson(courseId, courseToSend);
      setCourse(data);
      toast.success('Special class updated successfully');
    } catch (error) {
      console.log(error);
      toast.error(`Error updating special class: ${error.response.data.error.message}`);
    }
  };
  const handleSave = () => {
    if (courseId) {
      handleUpdateCourse();
    } else {
      handleCreateCourse();
    }
  };

  const formatedMaterial = course?.supportingMaterials?.map((material, index) => ({
    id: index,
    name: material.name,
    url: material.url,
  }));

  return (
    <div className="education__course">
      <div className="education__course__header">
        <h1>{courseId ? course?.name : 'New Course'}</h1>
        <Button variant="contained" onClick={handleSave}>
          {courseId ? 'Save' : 'Create'}
        </Button>
      </div>
      <form onSubmit={() => {}} className="education__course__edit__form">
        <div className="education__course__edit__form__fields">
          {courseId && (
            <div>
              <UneditableInput data={course} labels={uneditable} />
            </div>
          )}
          <div className="education__course__edit__form__fields__editable">
            <div className="education__course__edit__form__fields__editable__row">
              <TextField
                label="Name"
                value={course?.name}
                onChange={e => setCourse({ ...course, name: e.target.value })}
                className="education__course__edit__form__fields__editable__row__name"
              />
              <div className="education__course__new-lesson__form__row__duration">
                <TextField
                  type="number"
                  label="Duration (in seconds)"
                  value={course?.duration}
                  onChange={e => setCourse({ ...course, duration: e.target.value })}
                  className="education__course__edit__form__fields__editable__row__duration"
                />
                <span>{formatDuration(course?.duration)}</span>
              </div>
            </div>
            <EditableInput data={course} setData={setCourse} labels={editable} />
          </div>
        </div>

        <ContentEditor content={course?.content} setContent={value => setCourse({ ...course, content: value })} />

        <div className="education__course__new-lesson__form__supporting-materials">
          <div className="education__course__new-lesson__form__supporting-materials__header">
            <h2>Supporting Materials</h2>
            <Button
              variant="contained"
              onClick={() =>
                setCourse({
                  ...course,
                  supportingMaterials: [...course.supportingMaterials, { id: course.supportingMaterials.length, name: '', url: '' }],
                })
              }
            >
              <PlusIcon />
            </Button>
          </div>
          <div className="education__course__new-lesson__form__supporting-materials__list">
            {formatedMaterial?.map((material, index) => (
              <div key={index} className="education__course__new-lesson__form__supporting-materials__item">
                <div className="education__course__new-lesson__form__supporting-materials__item__left">
                  <TextField
                    label="Name"
                    value={material.name}
                    onChange={e =>
                      setCourse({
                        ...course,
                        supportingMaterials: course.supportingMaterials?.map((m, i) => (i === index ? { ...m, name: e.target.value } : m)),
                      })
                    }
                  />
                  <TextField
                    label="URL"
                    value={material.url}
                    onChange={e =>
                      setCourse({
                        ...course,
                        supportingMaterials: course.supportingMaterials?.map((m, i) => (i === index ? { ...m, url: e.target.value } : m)),
                      })
                    }
                  />
                </div>
                <Button
                  variant="contained"
                  onClick={() => setCourse({ ...course, supportingMaterials: course.supportingMaterials.filter((_, i) => i !== index) })}
                >
                  <TrashCanIcon />
                </Button>
              </div>
            ))}
          </div>
        </div>
      </form>
    </div>
  );
};

export default EducationSpecialClass;
